<template>
    <div>
        <form>
            <h4 class="font-weight-bold mt-5">{{ $lang('Odbiorcy') }}</h4>
            <div class="row">
                <div class="col-auto m-0">
                    <input type="checkbox" id="to-all" name="to-all"
                           v-model="toAll" @change="getRecipients"/>
                    <label for="to-all">{{ $lang('Do wszystkich') }}</label>
                </div>
            </div>

            <hr class="w-100 mt-0">

            <div class="row">
                <div class="form-group col-12 col-lg-12">
                    <input class="custom-radio" type="radio" name="client_type" :value="'byType'" id="selectLibrariesByType"
                           v-model="selectLibrariesType">
                    <label  for="selectLibrariesByType"><span class="mr-3">{{ $lang('Rodzaj biblioteki') }}</span></label>
                    <input class="custom-radio" type="radio" name="client_type" :value="'single'" id="selectSingleLibraries"
                           v-model="selectLibrariesType">
                    <label  for="selectSingleLibraries"><span>{{ $lang('Pojedyncze biblioteki') }}</span></label>
                    <span class="ml-2 text-red">({{ $lang('wymagane') }})</span>

                    <div v-if="selectLibrariesType === 'byType'">
                        <div class="pb-2">
                            <label for="roles">
                                {{ $lang('Role') }}
                                <span class="text-red">
                                    ({{ $lang('wymagane') }})
                                </span>
                            </label>
                            <multiselect
                                :searchable=false :close-on-select=false
                                id="roles" v-model="rolesChecked" :options="allRoles"
                                group-values="options" group-label="label" :group-select="true"
                                :multiple="true" label="name" track-by="id"
                                :placeholder="$lang('Wybierz role')"
                                :selectLabel="$lang('Wybierz rolę')"
                                :selectedLabel="$lang('Wybrane')"
                                :deselectLabel="$lang('Usuń rolę')"
                                :selectGroupLabel="$lang('Wybierz wszystkie role')"
                                :deselectGroupLabel="$lang('Usuń wszystkie role')"
                            ></multiselect>
                        </div>
                        <div v-for="(form, index) of forms"
                             :key="'form-' + index + '-' + form.libraryType"
                             class="row px-4 pt-1 col-md-12 align-items-end">
                            <div class="col-md-2">
                                <logical-operation-select
                                    v-if="form.logicalOperation && forms.length > 1 && index !== 0"
                                    :form-index="index"
                                    v-model="form.logicalOperation"
                                    :init-value="form.logicalOperation"
                                    @change="(operation) => onChangeLogicalOperation(form, operation)"
                                />
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label :for="'library-type-' + index" v-if="index === 0">
                                        {{ $lang('Wybierz typ biblioteki') }}
                                    </label>
                                    <select v-model="form.libraryType"
                                            :id="'library-type-' + index"
                                            class="form-control"
                                    >
                                        <option :value="activeTypeOption.name"
                                                :disabled="isUsedType(activeTypeOption.name)">
                                            {{ activeTypeOption.label }}
                                        </option>
                                        <option v-for="typeOption of library_type_options"
                                                :value="typeOption.name"
                                                :disabled="isUsedType(typeOption.name)"
                                                v-if="typeOption.available_projects.includes(project)"
                                        >
                                            {{ typeOption.label }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label :for="'library-type-value-' + index" v-if="index === 0">
                                        {{ $lang('Wartość') }}
                                    </label>
                                    <select
                                        v-model="form.value"
                                        class="form-control"
                                        :id="'library-type-value-' + index"
                                        @change="getRecipients"
                                    >
                                        <option :value="true" :selected="forms.length <= 1 ">
                                            {{ $lang("TAK") }}
                                        </option>
                                        <option :value="false">
                                            {{ $lang("NIE") }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4 pb-3" v-if="forms.length > 1">
                                <a href="#" @click.prevent="removeForm(index)">
                                    <i class="fa fa-trash"/>
                                    {{ $lang('Usuń warunek') }}
                                </a>
                            </div>
                        </div>
                        <div class="col-md-8 col-4 float-left" v-if="forms.length !== typeOptions.length">
                            <a href="#" class="btn btn-outline-secondary" @click.prevent="addForm">
                                {{ $lang('Dodaj warunek filtrowania bibliotek') }}
                            </a>
                        </div>
                    </div>
                    <div class="mt-1" v-if="selectLibrariesType === 'single'">
                        <multiselect
                            :searchable=true :close-on-select=false
                            id="selectLibraries" v-model="selectedLibraries" :options="allLibraries"
                            group-values="options" group-label="label" :group-select="true"
                            :multiple="true" label="name" track-by="id"
                            :placeholder="$lang('Wybierz biblioteki')"
                            :selectLabel="$lang('Wybierz bibliotekę')"
                            :selectedLabel="$lang('Wybrane')"
                            :deselectLabel="$lang('Usuń biblioteki')"
                            :selectGroupLabel="$lang('Wybierz wszystkie biblioteki')"
                            :deselectGroupLabel="$lang('Usuń wszystkie biblioteki')"
                        ></multiselect>
                        <div class="col-12 mt-3 ml-3" v-for="library in selectedLibraries">
                            <input name="libraries[]" :value="library.id" hidden>
                            <label class="mb-2">
                                {{library.name + ' - ' + $lang('role')}}
                                <span class="text-red">
                                    ({{ $lang('wymagane') }})
                                </span>
                            </label>
                            <multiselect
                                :searchable=false :close-on-select=false
                                :id="'rolesLibrary'+library.id" v-model="library.roles" :options="allRoles"
                                group-values="options" group-label="label" :group-select="true"
                                :multiple="true" label="name" track-by="id"
                                :placeholder="$lang('Wybierz role')"
                                :selectLabel="$lang('Wybierz rolę')"
                                :selectedLabel="$lang('Wybrane')"
                                :deselectLabel="$lang('Usuń rolę')"
                                :selectGroupLabel="$lang('Wybierz wszystkie role')"
                                :deselectGroupLabel="$lang('Usuń wszystkie role')"
                            ></multiselect>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="form-group col-12 col-lg-12">
                    <label for="modules">
                        {{ $lang('Moduły') }}
                        <span class="text-red">
                        ({{ $lang('opcjonalne') }})
                    </span>
                    </label>
                    <multiselect
                        :searchable=false
                        :close-on-select=false
                        id="modules"
                        v-model="modulesChecked"
                        :options="allModules"
                        group-values="options"
                        group-label="label"
                        :group-select="true"
                        :multiple="true"
                        label="name"
                        track-by="id"
                        :placeholder="$lang('Wybierz moduły')"
                        :selectLabel="$lang('Wybierz moduł')"
                        :selectedLabel="$lang('Wybrane')"
                        :deselectLabel="$lang('Usuń moduł')"
                        :selectGroupLabel="$lang('Wybierz wszystkie moduły')"
                        :deselectGroupLabel="$lang('Usuń wszystkie moduły')"
                        @input="getRecipients"
                    ></multiselect>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12 col-lg-12 pr-4">
                    <label class="col-12 pl-0" for="email">
                        {{ $lang('Adres Email') }}
                        <span class="text-red">({{ $lang('opcjonalne') }})</span>
                    </label>
                    <div class="input-group-prepend col-11 px-0 float-left">
                        <div class="bg-icon">
                            <i aria-hidden="true" class="fa fa-envelope-o"></i>
                        </div>
                        <input
                            class="form-control"
                            id="email"
                            name="email"
                            type="email"
                            v-model="emailInput"
                            :placeholder="$lang('Adres Email')"
                        >
                    </div>
                    <div class="col-1 float-left" @click.prevent="addEmail">
                        <a href="#" class="btn btn-outline-secondary">+</a>
                    </div>
                </div>

                <div class="col-12 p-0">
                    <ul>
                        <li v-for="(email, index) in emails">
                            <div class="col-12 text-break">
                                {{ email }}
                                <a
                                    @click.prevent="deleteEmail(index)"
                                    :aria-label="$lang('Usuń email' + email)"
                                    href="#"
                                    class="mr-4"
                                >
                                    <i aria-hidden="true" class="fa fa-trash"></i>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="row">
                <dl class="col-12 col-lg-12 float-left mt-4 pl-0">
                    <div class="col-12 float-left pl-0">
                        <dt class="col-auto float-left">
                            {{ $lang('Liczba instytucji') }}:
                        </dt>
                        <dd class="col-auto float-left">
                            {{ Object.keys(recipients).length }}
                        </dd>
                    </div>
                    <div class="col-12 col-lg-12 float-left pl-0">
                        <dt class="col-auto float-left">
                            {{ $lang('Liczba adresów') }}:
                        </dt>
                        <dd class="col-auto float-left">
                            {{ countRecipients() }}
                        </dd>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 float-right my-2">
                        <button
                            type="button"
                            :disabled="countRecipients() === 0"
                            @click.prevent="showModal('ADDRESSES')"
                            class="btn btn-default"
                        >
                            {{ $lang('Adresy e-mail') }}
                        </button>
                    </div>
                </dl>
            </div>

            <h4 class="font-weight-bold mt-5">{{ $lang('Email') }}</h4>

            <div class="row">
                <div class="form-group col-12 col-lg-8">
                    <label for="template">
                        {{ $lang('Szablon') }}
                        <span class="text-red">({{ $lang('wymagane') }})</span>
                    </label>
                    <select
                        class="form-control"
                        id="template"
                        name="template"
                        v-model="templateSelected"
                        @change="changeTemplate"
                    >
                        <option :value="0" selected>{{ $lang('Bez szablonu') }}</option>
                        <option v-for="template in templates" :value="template.id">
                            {{ template.name }}
                        </option>
                    </select>
                </div>
                <div class="form-group col-12 col-lg-4">
                    <datepicker-accessible
                        id="send-date"
                        :label-single="$lang('Data wysłania')"
                        custom-id="send-date"
                        name="send-date"
                        mode="datetime"
                        :use_pencil_checkbox="false"
                        :strong_label="false"
                        v-model="sendDate"
                        class="mt-0"
                    ></datepicker-accessible>
                </div>
            </div>

            <div class="row">
                <div class="form-group col-12 col-lg-12">
                    <label for="title">
                        {{ $lang('Tytuł') }}
                        <span class="text-red">({{ $lang('wymagane') }})</span>
                    </label>
                    <div class="input-group-prepend">
                        <div class="bg-icon">
                            <i aria-hidden="true" class="fa fa-envelope-o"></i>
                        </div>
                        <input
                            class="form-control"
                            id="title"
                            name="title"
                            v-model="title"
                            type="text"
                            :placeholder="$lang('Tytuł')"
                        >
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-lg-12">
                    <label for="editor-content">
                        {{ $lang('Treść') }}
                        <span class="text-red">({{ $lang('wymagane') }})</span>
                    </label>

                    <div class="form-group mb-2">
                        <input class="custom-radio" type="radio" name="content_type" :value="'text'" id="contentTypeText"
                               v-model="contentType">
                        <label for="contentTypeText"><span class="mr-3">{{ $lang('Tekst') }}</span></label>
                        <input class="custom-radio" type="radio" name="content_type" :value="'html'" id="contentTypeHTML"
                               v-model="contentType">
                        <label for="contentTypeHTML"><span>{{ $lang('HTML') }}</span></label>
                    </div>

                    <vue-editor
                        v-if="contentType === 'text'"
                        id="editor-content"
                        ref="editoralert"
                        v-model="content"
                        @text-change="changeAlertContent"
                        useCustomImageHandler
                        @image-added="handleImageAdded"
                        :editorOptions="editorSettings"
                        :editor-toolbar="customToolbar"
                        @mouseover.native="editor = 'cms-editor-content'"
                    >
                    </vue-editor>

                    <template v-if="contentType === 'html'">
                        <template v-if="!htmlContent">
                            <label for="htmlContentDropzone">
                                {{ $lang('Wgraj plik') }}
                            </label>
                            <dropzone
                                id="htmlContentDropzone"
                                ref="htmlContentDropzone"
                                :event_prefix="dropzoneEventPrefixes.html"
                                :route_store="upload_html_content_file_route"
                                :route_delete="delete_html_content_file_route"
                                :editable="true"
                                :max_files="1"
                                :accepted_files="'.html'"
                            ></dropzone>
                            <div class="my-2">{{ $lang('lub dodaj kod HTML') }}</div>
                        </template>
                        <textarea
                            class="form-control mt-2"
                            rows="10"
                            name="editor-content"
                            id="editor-content"
                            v-model="htmlContent"
                        ></textarea>
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-lg-12">
                    <label for="cms-editor-footer">
                        {{ $lang('Stopka') }}
                        <span class="text-red" v-if="contentType === 'text'">({{ $lang('wymagane') }})</span>
                        <span class="text-red" v-if="contentType === 'html'">({{ $lang('opcjonalne') }})</span>
                    </label>

                    <vue-editor
                        id="cms-editor-footer"
                        ref="editoralert"
                        v-model="footer"
                        @text-change="changeAlertContent"
                        useCustomImageHandler
                        @image-added="handleImageAdded"
                        :editorOptions="editorSettings"
                        :editor-toolbar="customToolbar"
                        @mouseover.native="editor = 'cms-editor-footer'"
                    >
                    </vue-editor>
                    <input
                        class="ml-1"
                        type="checkbox"
                        id="default-footer"
                        name="default-footer"
                        v-model="defaultFooter"
                    />
                    <label for="default-footer">{{ $lang('Dołącz domyślną stopkę') }}</label>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-lg-12">
                    <label>
                        {{ $lang('Załączniki') }}
                        <span class="text-red">({{ $lang('opcjonalne') }})</span>
                    </label>
                    <dropzone
                        id="attachment"
                        ref="dropzone"
                        :event_prefix="dropzoneEventPrefixes.attachments"
                        :route_store="upload_attachment_route"
                        :route_delete="delete_attachment_route"
                        :prevent_duplicates="true"
                    ></dropzone>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 float-right mx-2 pb-3">
                <button @click.prevent="sendEmail" class="btn btn-primary float-right ml-2" type="submit">
                    {{ $lang('Wyślij') }}
                </button>
                <button v-if="!modal_mode" @click.prevent="saveDraft" class="btn btn-primary float-right ml-2"
                        type="submit">{{ $lang('Zapisz') }}
                </button>
                <button @click.prevent="showModal('PREVIEW')" class="btn btn-default float-right ml-2" type="submit">
                    {{ $lang('Podgląd') }}
                </button>
                <button @click.prevent="sendTestEmail" class="btn btn-default float-right" type="submit">
                    {{ $lang('Wysyłka testowa') }}
                </button>
            </div>
        </form>

        <div class="modal fade" id="preview_modal" tabindex="-1">
            <div class="modal-dialog modal-lg modal-email">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Podgląd') }}</h5>
                        <button type="button" class="close" @click.prevent="hideModal('PREVIEW')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body default-headers">
                        <h1>{{ title }}</h1>
                        <div class="col-12 col-lg-12 text-break h-auto overflow-hidden ql-snow">
                            <div v-if="contentType === 'text'" class="ql-editor" v-html="content"></div>
                            <div v-if="contentType === 'html'" v-html="htmlContent"></div>
                        </div>
                        <hr class="w-100 m-0">
                        <div class="col-12 col-lg-12 text-break h-auto overflow-hidden ql-snow">
                            <div class="ql-editor">
                                <small v-html="footer"></small>
                                <small v-if="defaultFooter" v-html="default_footer.footer ">
                                </small>
                            </div>
                        </div>
                        <div class="col-12" v-if="showAttachments">
                            <strong>
                                <i aria-hidden="true" class="fa fa-paperclip mr-1"> {{ $lang("Załączniki") }}:</i>
                            </strong>
                            <ul>
                                <li v-for="(filename) in attachmentFilenames">
                                    {{ filename }}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click.prevent="hideModal('PREVIEW')">
                            {{ $lang('Zamknij') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addresses_modal" tabindex="-1">
            <div class="modal-dialog modal-lg modal-email">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Adresy e-mail') }}</h5>
                        <button type="button" class="close" @click.prevent="hideModal('ADDRESSES')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(libraryRecipients, index) in recipients" class="accordion"
                             :id="'accordion-' + libraryRecipients[0].library_id">
                            <div class="accordion-group col-12 col-sm-4 float-left mb-2">
                                <div class="accordion-heading">
                                    <a class="accordion-toggle" data-toggle="collapse"
                                       :href="'#collapse-' + libraryRecipients[0].library_id">
                                        <strong>{{ index }}</strong>
                                    </a>
                                </div>
                                <div :id="'collapse-' + libraryRecipients[0].library_id"
                                     class="accordion-body collapse in">
                                    <div v-for="libraryRecipient in libraryRecipients" class="accordion-inner">
                                        {{ libraryRecipient.email }}
                                        <small v-if="libraryRecipient.roleName != 'Nie Dotyczy'">
                                            ({{ libraryRecipient.roleName }}) </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="emails.length !== 0" class="accordion" id="accordion-emails">
                            <div class="accordion-group col-12 col-sm-4 float-left">
                                <div class="accordion-heading">
                                    <a class="accordion-toggle" data-toggle="collapse" :href="'#collapse-emails'">
                                        <strong>{{ $lang('Dodatkowe adresy') }}</strong>
                                    </a>
                                </div>
                                <div id="collapse-emails" class="accordion-body collapse in">
                                    <div v-for="email in emails" class="accordion-inner">
                                        {{ email }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" @click.prevent="hideModal('ADDRESSES')">
                            {{ $lang('Zamknij') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import ImageResize from 'quill-image-resize-module';
import Notification from '../../mixins/show-notification';
import axios from "axios";
import EditorArias from '../../mixins/cms-editor-arias';
import {EventBus} from "../../mixins/event-bus";
import Multiselect from "vue-multiselect";
import Dropzone from "../dropzone.vue";
import LogicalOperationSelect from "./logical-filter/logical-operation-select";
import Quill from "quill";
import _ from "lodash";

export default {
    name: "new-mail",
    components: {
        ImageResize,
        VueEditor,
        LogicalOperationSelect,
        Multiselect,
        Dropzone
    },
    mixins: [Notification, EditorArias],
    props: {
        send_route: {
            type: String,
        },
        upload_attachment_route: {
            type: String,
        },
        delete_attachment_route: {
            type: String,
        },
        upload_html_content_file_route: {
            type: String,
        },
        delete_html_content_file_route: {
            type: String,
        },
        recipients_route: {
            type: String,
        },
        test_route: {
            type: String,
        },
        mailing_route: {
            type: String,
        },
        drafts_route: {
            type: String,
        },
        save_draft_route: {
            type: String,
        },
        upload_image_route: {
            type: String,
        },
        templates: {
            type: Array,
            default: () => [],
        },
        libraries: {
            type: Array,
            default: () => [],
        },
        modules: {
            type: Array,
            default: () => [],
        },
        roles: {
            type: Array,
            default: () => [],
        },
        draft: {
            type: Object,
        },
        modal_mode: {
            type: Boolean,
            default: false,
        },
        default_footer: {
            type: Object
        },
        library_type_options: {
            type: Object|Array
        },
        project: {
            type: String
        }
    },
    created() {
        //set timezone CEST
        let date = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' }));
        date.setMinutes(date.getMinutes() + 5);
        let tzoffset = (date).getTimezoneOffset() * 60000;
        this.sendDate = (new Date(date - tzoffset)).toISOString().slice(0, -1);
        this.prepareRolesChecked();
        this.prepareModulesChecked();
        this.prepareLibraryTypes();
        this.prepareLibraries();
        this.prepareAttachments();
        this.prepareContent();
        this.getRecipients();
        this.listenForDropzoneEvents();
    },
    data() {
        return {
            editorSettings: {
                modules: {
                    imageResize: {},
                    imageDropAndPaste: {
                        handler: this.handleImageDropPaste,
                    },
                },
            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"],
                [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }, { 'background': [] }],
                ['link', 'image', 'video'],
                ["clean"]
            ],
            allRoles: [{
                label: 'Wszystkie',
                options: this.roles
            }],
            rolesChecked: [],
            allModules: [{
                label: 'Wszystkie',
                options: this.modules
            }],
            modulesChecked: [],
            toAll: this.draft ? this.draft.to_all === 1 : false,
            title: this.draft ? this.draft.title : '',
            content: '',
            footer: this.draft ? this.draft.footer : '',
            emails: this.draft && this.draft.emails !== "" ? JSON.parse(this.draft.emails) : [],
            emailInput: '',
            sendDate: this.draft ? this.draft.send_date : "2021-08-11T03:59:00",
            minDate: new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Warsaw' })),
            templateSelected: this.draft ? this.draft.template_id : 0,
            defaultFooter: this.draft ? this.draft.default_footer === 1 : true,
            recipients: [],
            forms: [{
                libraryType: 'active',
                value: true,
                logicalOperation: '',
            }],
            allLibraries: [{
                label: this.$lang('Wszystkie'),
                options: this.libraries,
            }],
            selectedLibraries: [],
            attachments: [],
            typeOptions: [
                {value: 'active', label: this.$lang('Aktywna')},
                {value: 'saas', label: this.$lang('SaaS')},
                {value: 'bookingplace', label: this.$lang('Booking Place')},
                {value: 'www_readonly', label: this.$lang('WWW tylko do odczytu')},
                {value: 'surveys_only', label: this.$lang('Dostęp tylko do ankiet')},
            ],
            showAttachments: false,
            attachmentFilenames: [],
            editor: null,
            selectLibrariesType: 'byType',
            previousSelectedLibrariesLength: 0,
            activeTypeOption: {
                name: 'active', label: this.$lang('Aktywna')
            },
            contentType: 'text',
            htmlContent: '',
            dropzoneEventPrefixes: {
                html: 'html-',
                attachments: 'attachments-'
            }
        }
    },
    methods: {
        showDuplicateMessage(filename) {
            this.showNotification('error', this.$lang('Plik') + ' ' + filename + ' ' + this.$lang('już istnieje'));
        },
        changeTemplate() {
            if (this.templateSelected === 0) {
                this.content = "";
                this.footer = "";
            } else {
                let template = this.templates.find(temp => temp.id === this.templateSelected);
                this.content = template.content;
                this.footer = template.footer;
            }
        },

        handleImageAdded(file, Editor, cursorLocation, resetUploader) {
            let formData = new FormData();
            //Show notification when file >= 5MB
            if (file.size >= 6291456) {
                this.showNotification('error', this.$lang('Za duży rozmiar pliku. (Maksymalny rozmiar: 6MB)'));
                return;
            }
            formData.append("image", file);
            axios.post(this.upload_image_route, formData)
                .then(result => {
                    let url = result.data.url; // Get url from response
                    Editor.insertEmbed(cursorLocation, "image", url);
                    resetUploader();
                })
                .catch(err => {
                    const errors = err.response.data.errors;
                    if (errors) {
                        Object.values(errors).forEach(error => {
                            error.forEach(message => this.showNotification('error', this.$lang(message)));
                        });
                    }
                });
        },

        handleImageDropPaste(imageDataUrl, type, imageData) {
            const file = imageData.toFile();
            const formData = new FormData();

            //Show notification when file >= 5MB
            if (imageData.size >= 5242880) {
                this.showNotification('error', this.$lang('Za duży rozmiar pliku. (Maksymalny rozmiar: 5MB)'));
                return;
            }

            formData.append('image', file);

            axios.post(this.upload_image_route, formData)
                .then(result => {
                    let url = result.data.url; // Get url from response
                    let container = document.querySelector('#' + this.editor);
                    let editor = Quill.find(container);
                    let index = (editor.getSelection() || {}).index;

                    if (index === undefined || index < 0) {
                        index = editor.getLength();
                    }
                    editor.insertEmbed(index, 'image', url);
                })
                .catch(err => {
                    const errors = err.response.data.errors;
                    if (errors) {
                        Object.values(errors).forEach(error => {
                            error.forEach(message => this.showNotification('error', this.$lang(message)));
                        });
                    }
                });
        },

        prepareRolesChecked() {
            if (this.draft) {
                if (this.draft.roles !== "" && this.draft.roles !== null) {
                    JSON.parse(this.draft.roles).forEach((role) => {
                        if (this.draft && this.rolesChecked.find(roleChecked => roleChecked.name === role.name ||
                            roleChecked.name === 'Pracownik SBS')) {
                            return true;
                        }
                        if (role.name !== 'Nie Dotyczy') {
                            this.rolesChecked.push(role);
                        } else {
                            role.name = this.$lang('Pracownik SBS');
                            this.rolesChecked.push(role);
                        }
                    });
                    this.selectLibrariesType = 'byType';
                } else {
                    this.selectLibrariesType = 'single';
                }
            } else {
                this.roles.forEach((role) => {
                    if (this.draft && this.rolesChecked.find(roleChecked => roleChecked.name === role.name ||
                        roleChecked.name === 'Pracownik SBS')) {
                        return true;
                    }
                    if (role.name !== 'Nie Dotyczy') {
                        this.rolesChecked.push(role);
                    } else {
                        role.name = this.$lang('Pracownik SBS');
                        this.rolesChecked.push(role);
                    }
                });
            }
        },
        prepareModulesChecked() {
            if (this.draft && this.draft.modules !== "") {
                JSON.parse(this.draft.modules).forEach((module) => {
                    this.modulesChecked.push(module);
                });
            }
        },
        prepareLibraryTypes() {
            if (this.draft) {
                if (this.draft.library_types !== null && this.draft.library_types !== "[]") {
                    this.selectLibrariesType = 'byType';
                    this.forms = [];
                    JSON.parse(this.draft.library_types).forEach((libraryType) => {
                        this.forms.push(libraryType);
                    });
                } else {
                   this.selectLibrariesType = 'single';
                }
            }
        },
        prepareLibraries() {
            if (this.draft) {
                if (this.draft.libraries !== null && this.draft.libraries !== "[]") {
                    this.selectLibrariesType = 'single';
                    this.selectedLibraries = [];
                    JSON.parse(this.draft.libraries).forEach((library) => {
                        this.selectedLibraries.push(library);
                    });
                    this.previousSelectedLibrariesLength = this.selectedLibraries.length;
                } else {
                    this.selectLibrariesType = 'byType';
                }
            }
        },
        prepareAttachments() {
            if (this.draft && this.draft.attachments !== "[]") {
                let attachments = this.draft.attachments !== '' ? JSON.parse(this.draft.attachments) : [];
                for (let key = 0; key < attachments.length; key++) {
                    axios.head('/storage/attachments/mailing/' + attachments[key].hash + '/' + attachments[key].hash)
                        .then(response => {
                        const file = {
                            size: response.headers['content-length'],
                            name: attachments[key].filename,
                            hash: attachments[key].hash
                        };
                        this.$refs.dropzone.$refs.myVueDropzone.manuallyAddFile(file,
                            '/storage/attachments/mailing/' + attachments[key].hash + '/' + attachments[key].hash);
                        this.attachments.push(attachments[key]);
                        this.hasAttachments();
                    }).catch(err => {
                        console.log(err);
                    });
                }
            }
        },
        prepareContent() {
            if (this.draft) {
                this.contentType = !this.draft.has_html_content ? 'text' : 'html';
                if (this.draft.has_html_content) {
                    this.content = '';
                    this.htmlContent = this.draft.content;
                } else {
                    this.content = this.draft.content;
                    this.htmlContent = '';
                }
            }
        },
        sendEmail() {
            if (this.selectLibrariesType === 'byType' && this.rolesChecked.length === 0) {
                this.showNotification('error', this.$lang('Zaznacz role.'));
                return;
            }
            if (this.forms.length === 0 && this.selectedLibraries.length === 0) {
                this.showNotification('error', this.$lang('Wybierz rodzaj lub pojedyncze biblioteki.'));
                return;
            }
            if (this.selectLibrariesType === 'single'
                && this.selectedLibraries.some(selectedLibrary => !selectedLibrary.hasOwnProperty('roles') || selectedLibrary['roles'].length === 0)) {
                this.showNotification('error', this.$lang('Zaznacz role dla pojedynczej biblioteki.'));
                return;
            }
            let params = {
                sendDate: this.sendDate,
                emails: this.emails,
                hasHtmlContent: (this.contentType === 'html'),
                template: {
                    title: this.title,
                    content: (this.contentType === 'text') ? this.content : this.htmlContent,
                    footer: this.footer,
                },
                toAll: this.toAll,
                allModules: this.allModules,
                modules: this.modulesChecked,
                roles: this.rolesChecked,
                defaultFooter: this.defaultFooter,
                templateId: this.templateSelected,
                selectLibrariesType: this.selectLibrariesType,
                libraryTypes: this.forms,
                libraries: this.selectedLibraries,
                manualAttachments: this.attachments
            }
            if (this.modal_mode && this.isSameDraft() ||
                this.save_draft_route && this.draft) {
                params.draftId = this.draft.id;
            }
            if (this.save_draft_route && this.draft) {
                params.draftMode = true;
            }

            document.cookie = "tabID = " + sessionStorage.getItem('tabID');

            axios.post(this.send_route, params
            ).then(response => {
                let data = response.data;
                if (data.sent) {
                    this.showNotification('success', this.$lang('Zrealizowano wysyłkę mailingową.'));
                    EventBus.$emit('newMailingHistory');
                    if (data.sentDraft) {
                        window.location.href = this.drafts_route;
                    } else if (!this.modal_mode) {
                        window.location.href = this.mailing_route;
                    } else if (this.modal_mode) {
                        $("#resend-modal").modal("hide");
                    }
                } else {
                    this.showNotification('error', this.$lang("Wystąpił błąd"))
                }
            }).catch(err => {
                const errors = err.response.data.errors;
                console.log(err.response);
                Object.values(errors).forEach(error => {
                    error.forEach(message => this.showNotification('error', this.$lang(message)));
                });
            });
        },

        getRecipients() {
            let params = {
                emails: this.emails,
                toAll: this.toAll,
                allModules: this.allModules,
                modules: this.modulesChecked,
                roles: this.rolesChecked,
                selectLibrariesType: this.selectLibrariesType,
                libraryTypes: this.forms,
                libraries: this.selectedLibraries,
            }
            axios.post(this.recipients_route, params
            ).then(response => {
                let data = response.data;
                if (data) {
                    this.recipients = this.sortObject(data.recipients);
                }
            }).catch(err => {
                const errors = err.response.data.errors;
                Object.values(errors).forEach(error => {
                    error.forEach(message => this.showNotification('error', this.$lang(message)));
                });
            });
        },
        sortObject(o) {
            return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
        },

        sendTestEmail() {
            let params = {
                sendDate: this.sendDate,
                emails: this.emails,
                hasHtmlContent: (this.contentType === 'html'),
                template: {
                    title: this.title,
                    content: (this.contentType === 'text') ? this.content : this.htmlContent,
                    footer: this.footer,
                },
                toAll: this.toAll,
                allModules: this.allModules,
                modules: this.modulesChecked,
                roles: this.rolesChecked,
                defaultFooter: this.defaultFooter,
                selectLibrariesType: this.selectLibrariesType,
                libraryTypes: this.forms,
                libraries: this.selectedLibraries,
            }
            axios.post(this.test_route, params
            ).then(response => {
                let data = response.data;
                if (data.sent) {
                    this.showNotification('success', this.$lang('Zrealizowano wysyłkę testową.'));
                }
            }).catch(err => {
                const errors = err.response.data.errors;
                Object.values(errors).forEach(error => {
                    error.forEach(message => this.showNotification('error', this.$lang(message)));
                });
            });
        },

        saveDraft() {
            let params = {
                id: this.draft ? this.draft.id : 0,
                templateId: this.templateSelected,
                sendDate: this.sendDate,
                emails: this.emails,
                hasHtmlContent: (this.contentType === 'html'),
                template: {
                    title: this.title,
                    content: (this.contentType === 'text') ? this.content : this.htmlContent,
                    footer: this.footer,
                },
                toAll: this.toAll,
                allModules: this.allModules,
                modules: this.modulesChecked,
                roles: this.rolesChecked,
                defaultFooter: this.defaultFooter,
                selectLibrariesType: this.selectLibrariesType,
                libraryTypes: this.forms,
                libraries: this.selectedLibraries,
                manualAttachments: this.attachments
            }

            document.cookie = "tabID = " + sessionStorage.getItem('tabID');

            axios.post(this.save_draft_route, params
            ).then(response => {
                let data = response.data;
                if (data.save) {
                    this.showNotification('success', this.$lang('Zapisano wersję roboczą.'));
                    if (!this.modal_mode) {
                        window.location.href = this.drafts_route !== undefined ? this.drafts_route : this.mailing_route;
                    } else if (this.modal_mode) {
                        $("#resend-modal").modal("hide");
                    }
                }
            }).catch(err => {
                const errors = err.response.data.errors;
                console.log(errors);
                Object.values(errors).forEach(error => {
                    console.log(error);
                    error.forEach(message => this.showNotification('error', this.$lang(message)));
                });
            });
        },

        changeAlertContent(e) {
            let component = this;
            e.forEach(function (ops) {
                if (ops.hasOwnProperty('insert') &&
                    typeof ops.insert.charCodeAt === 'function' &&
                    ops.insert.charCodeAt(0) === 9) { //tabulation
                    if (typeof component.$refs.editoralert.forEach === 'function') {
                        component.$refs.editoralert.forEach(function (item) {
                            window.setTimeout(function () {
                                jQuery('#saveContentAlert').focus();
                            }, 0);
                        });
                    }
                }
            });
        },

        addEmail() {
            const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (this.emailInput === "") {
                this.showNotification('error', this.$lang('Pole email nie może być puste.'));
                return;
            }
            if (!emailRegex.test(this.emailInput.toLowerCase())) {
                this.showNotification('error', this.$lang('Podana wartość musi być adresem email.'));
                return;
            }
            if (!this.emails.find(email => email === this.emailInput)) {
                this.emails.push(this.emailInput);
            } else {
                this.showNotification('error', this.$lang('Adres email jest już na liście.'));
            }
            this.emailInput = '';
        },

        deleteEmail(index) {
            this.emails.splice(index, 1);
        },

        showModal(type) {
            if (type === "PREVIEW") {
                $("#preview_modal").modal("show");
            }
            if (type === "ADDRESSES") {
                $("#addresses_modal").modal("show");
            }
        },
        hideModal(type) {
            if (type === "PREVIEW") {
                $("#preview_modal").modal("hide");
            }
            if (type === "ADDRESSES") {
                $("#addresses_modal").modal("hide");
            }
        },
        isSameDraft() {
            return JSON.stringify(this.rolesChecked) === JSON.stringify(JSON.parse(this.draft.roles)) &&
                JSON.stringify(this.modulesChecked.length !== 0 ? this.modulesChecked : "") === JSON.stringify(this.draft.modules !== "" ? JSON.parse(this.draft.modules) : "") &&
                JSON.stringify(this.emails.length !== 0 ? this.emails : "") === JSON.stringify(this.draft.emails !== "" ? JSON.parse(this.draft.emails) : "") &&
                this.toAll == this.draft.to_all &&
                this.libraryTypes == this.draft.library_types &&
                this.libraries == this.draft.libraries &&
                this.defaultFooter == this.draft.default_footer &&
                this.templateSelected == this.draft.template_id &&
                this.title == this.draft.title &&
                this.content == this.draft.content &&
                this.footer == this.draft.footer;
        },
        countRecipients() {
            if (this.rolesChecked === [] && !this.toAll) {
                return 0;
            }
            let addresses = 0;
            Object.values(this.recipients).forEach(libraryRecipients => addresses += libraryRecipients.length);
            return addresses + this.emails.length;
        },
        showDetails(id) {
            let div = $().getElementById('details-' + id);
            let btn = $().getElementById('details-btn-' + id);
            let span = $().getElementById('details-span-' + id);
            if (div.hidden === false) {
                div.hidden = true;
                btn.classList.remove('fa-angle-double-up')
                btn.classList.add('fa-angle-double-down')
                span.innerText = this.$lang('Rozwiń');
            } else {
                div.hidden = false;
                btn.classList.remove('fa-angle-double-down')
                btn.classList.add('fa-angle-double-up')
                span.innerText = this.$lang('Zwiń');
            }
        },
        onChangeSelectValue(form, value) {
            if (typeof form !== 'object') {
                this.showNotification('error', this.$lang('Wystąpił błąd'));
                return;
            }
            form.libraryTypeValue = value;
            this.getRecipients();
        },
        onChangeLogicalOperation(form, operation) {
            if (typeof form !== 'object') {
                this.showNotification('error', this.$lang('Wystąpił błąd'));
                return;
            }
            form.logicalOperation = operation;
            this.getRecipients();
        },
        getEmptyFormObject(logicalOperation = '') {
            let firstAvailableType = this.typeOptions.find(element => this.forms.find(form => form.libraryType === element.value) === undefined);
            return {
                libraryType: firstAvailableType.value,
                value: true,
                logicalOperation: logicalOperation
            };
        },
        addForm() {
            let newForm = this.getEmptyFormObject('AND');
            if (newForm.libraryType !== "active") {
                newForm.value = false;
            }
            this.forms.push(newForm);
            this.getRecipients();
        },
        removeForm(formIndex) {
            this.forms.splice(formIndex, 1);
            if (this.forms.length === 1) {
                this.forms[0].value = true;
            }
            if (this.forms.length > 0) {
                this.forms[0].logicalOperation = '';
            }
            this.getRecipients();
        },
        onLibraryTypeChange(form, libraryType) {
            if (typeof form !== 'object') {
                this.showNotification('error', this.$lang('Wystąpił błąd'));
                return;
            }
            form.libraryType = libraryType;
        },
        isUsedType(option) {
            return this.forms.find(form => form.libraryType === option) !== undefined;
        },
        deleteAttachment(data) {
            let hash = data.file.hash;
            if (hash) {
                const index = this.attachments.findIndex(attachment => attachment.hash === hash);
                if (index !== undefined) {
                    this.attachments.splice(index, 1);
                }
            }
        },
        hasAttachments() {
            try {
                this.showAttachments = this.$refs.dropzone.$refs.myVueDropzone.dropzone.files.length > 0;
                if (this.showAttachments) {
                    this.attachmentFilenames = this.$refs.dropzone.$refs.myVueDropzone.dropzone.files.map(file => file['name']);
                }
            } catch (e) {

            }
        },
        listenForDropzoneEvents() {
            EventBus.$on(this.dropzoneEventPrefixes.attachments+'dropzone-removed-file', payload => {
                this.deleteAttachment(payload);
                this.hasAttachments();
            });
            EventBus.$on(this.dropzoneEventPrefixes.attachments+'dropzone-complete', payload => {
                this.hasAttachments();
            });
            EventBus.$on(this.dropzoneEventPrefixes.attachments+'dropzone-duplicated', filename => {
                this.showDuplicateMessage(filename);
            });

            EventBus.$on(this.dropzoneEventPrefixes.html+'dropzone-complete', payload => {
                let self = this;
                let reader = new FileReader();
                reader.onload = function(event) {
                    self.htmlContent = event.target.result;
                    self.sendRemoveHtmlContentFileRequest(payload.file);
                };
                reader.readAsText(payload.file);
            });
        },
        sendRemoveHtmlContentFileRequest(file) {
            EventBus.$emit(this.dropzoneEventPrefixes.html+'dropzone-remove-file', file);
        }
    },
    watch: {
        selectLibrariesType: {
            handler() {
                if (this.selectLibrariesType === 'byType') {
                    this.selectedLibraries = [];
                    this.forms.push({
                        libraryType: 'active',
                        value: true,
                        logicalOperation: '',
                    });
                } else if (this.selectLibrariesType === 'single') {
                    this.forms = [];
                    this.rolesChecked = [];
                }
            }
        },
        forms: {
            deep: true,
            handler() {
                if (this.forms.length > 0 && this.rolesChecked.length > 0) {
                    this.getRecipients();
                }
            }
        },
        rolesChecked: {
            handler() {
                if (this.rolesChecked.length === 0) {
                    this.recipients = [];
                } else {
                    this.getRecipients();
                }
            }
        },
        selectedLibraries: {
            deep: true,
            handler() {
                if (this.selectedLibraries.length === 0) {
                    this.recipients = [];
                } else {
                    if (this.selectedLibraries.length > 1
                        && this.previousSelectedLibrariesLength < this.selectedLibraries.length) {
                        this.selectedLibraries.at(-1).roles = _.cloneDeep(this.selectedLibraries.at(-2).roles);
                        this.getRecipients();
                    } else {
                        if (this.selectedLibraries.some(selectedLibrary => selectedLibrary['roles'].length > 0)) {
                            this.getRecipients();
                        } else {
                            this.recipients = [];
                        }
                    }
                }
                this.previousSelectedLibrariesLength = this.selectedLibraries.length;
            }
        }
    }
}
</script>
